<template>
  <a-modal :title="ModalTitle" v-model="visible" :confirmLoading="confirmLoading"
    cancelText="取消" okText="保存" width="700px"
    @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item v-for="(item, index) of formData" :key="index" 
        :label="item.label" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input v-if="item.type === 'input'" v-decorator="[item.name, { rules: item.rules }]"/>
        <a-date-picker v-if="item.type === 'date'" style="width: 100%"  v-decorator="[item.name, { rules: item.rules }]" format="YYYY-MM-DD"/>
        <a-select v-else-if="item.type === 'select'" placeholder="请选择"
           v-decorator="[item.name, { rules: item.rules }]" showSearch :filterOption="filterOption">
          <a-select-option v-for="(d, index) of seleteItems[item.items.data]" :key="index" :value="d[item.items.value]">{{ d[item.items.label] }}</a-select-option>
        </a-select>
        <a-select v-else-if="item.type === 'selects'" placeholder="请选择"
           v-decorator="[item.name, { rules: item.rules }]" showSearch :filterOption="filterOption" :disabled="modalData ? true : false">
          <a-select-option v-for="(d, index) of seleteItems[item.items.data]" :key="index" :value="d[item.items.value]">{{ d[item.items.label] }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
const formData = [
  {
    name: 'course_cate_id',
    label: '课程科目',
    type: 'selects',
    rules: [{ required: true, message: '请输入课程科目!' }],
    items: {
      data: 'classCategorys',
      label: 'filter_name',
      value: 'course_cate_id'
    }
  },
  {
    name: 'certificate_level',
    label: '证书级别',
    type: 'select',
    rules: [{ required: true, message: '请输入证书级别!' }],
    items: {
      data: 'certificateLevels',
      label: 'label',
      value: 'value'
    }
  },
  {
    name: 'certificate_name',
    label: '证书名称',
    type: 'input',
    rules: [{ required: true, message: '请输入证书名称!' }]
  },
]
import C_ITEMS from '@/utils/items'
export default {
  name: 'EditModal',
  inject: ['parent'],
  props: {
    modalData: Object
  },

  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      ModalTitle: '新增证书',
      visible: false,
      confirmLoading: false,
      formData,
      form: this.$form.createForm(this),
      seleteItems: {
        classCategorys:[],
        certificateLevels: C_ITEMS.certificateLevels
      },
    }
  },

  async created() {
    this.visible = true
    this.getClassCategory()
    await this.$nextTick()
    if (this.modalData) {
      this.ModalTitle = '编辑证书'
      let { modalData } = this
      let formFields = {}
      for (let d of formData) {
        formFields[d.name] = modalData[d.name]
      }
      this.form.setFieldsValue(formFields)
    }
  },

  beforeDestroy() {
    this.visible = false
  },

  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async getClassCategory() {
      let res = await this.$store.dispatch('searchCourseTypeAction', {})
      this.seleteItems.classCategorys = res.data
    },
    async handleOk() {
      this.confirmLoading=true;
      try {
        const { modalData, form } = this
        let params = await form.validateFields()
        if (params) {
          console.log(modalData)
          if (modalData) {
            params.cert_id = modalData.cert_id
          }
          let res = await this.$store.dispatch(modalData ? 'courseCertificateEditAction' : 'courseCertificateAddAction', { data: params })
          if(res) {
            form.resetFields()
            this.parent.hideEditModal(1)
          }
        }
      } catch {
      }
			this.confirmLoading=false;
    },
    handleCancel() {
      this.parent.hideEditModal(0)
    },
  }
}
</script>
